import React, { useEffect } from "react";
import "./banner.scss";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "../header/Navbar";
import Spline from "@splinetool/react-spline";

const Banner = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div className="important_div">
        <section className="main-banner">
          <img src="\assets\bannerbg.png" className="bannerbg" />

          <div className="container-fluid onlysformobile">
            <div className="custom-container">
              <div className="onlyforflex_s">
                <div className="maincenterdiv">
                  <button className="pprotocoldd_new">
                  Estate Slice NFT
                  </button>
                  <h2 className="parafirstcc">
                    Tokenizing the World's Premium Real Estate
                  </h2>
                  <p className="parafirstff">
                   Real estate investing made simple. Buy and sell fractional shares of premium properties with just a few clicks.
                  </p>
                </div>
                {/* <Link to="/mint">
                    <button className="mintbutton">Mint Your NFT</button>
                  </Link> */}
                {/* <div className="leftside_3D">
                  <Spline scene="https://prod.spline.design/5w2xqO7VDfzp73FC/scene.splinecode" className="img-fluid" />
                  <Spline scene="https://prod.spline.design/sIRTOduz8wPVRGjn/scene.splinecode" />
                  
                </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Banner;
